import Input from '../../components/Form/Input'
import React, { useRef, useEffect, useState } from "react";
import { SubmitHandler, FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import * as Yup from 'yup';
import { alertService, authenticationService } from "services";

interface FormData {
    email: string
    password: string
}

const LoginUser = (props: any) => {

    const formRef = useRef<FormHandles>(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (authenticationService.currentUserValue) {
            window.location.href = '/';
        }
    });

    const handleSubmit: SubmitHandler<FormData> = async data => {
        try {
            const schema = Yup.object().shape({
                email: Yup.string().email("Informe um e-mail válido").required("E-mail obrigatório"),
                password: Yup.string().required("Senha obrigatório"),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            formRef.current?.setErrors({});

            try {
                setSaving(true);
                await authenticationService.login(data.email, data.password);

                formRef.current?.reset();

                const { from } = props.location.state || { from: { pathname: "/" } };
                window.location.href = from.pathname;
            } catch (error) {
                setSaving(false);
                alertService.error(error);
            }
        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                let errorMessages: { [key in string]: string };
                errorMessages = {};
                err.inner.forEach((error: Yup.ValidationError) => {
                    errorMessages[error.path!] = error.message;
                });
                formRef.current?.setErrors(errorMessages);
            }
        }
    }

    return (
        <div className="container">
            <Form ref={formRef} onSubmit={handleSubmit}>
                <h3 className="display-5 font-weight-light text-secondary">Entrar</h3>
                <p className="lead font-weight-light text-secondary">Preencha os dados abaixo para fazer o login.</p>
                <div className="jumbotron shadow rounded bg-white mt-5 p-5">
                    <Input label="E-mail" name="email" type="email" placeholder="Insira seu e-mail" />
                    <Input label="Senha" name="password" type="password" placeholder="Insira sua senha" />

                    <p className="p-0 lead font-weight-light text-secondary">Esqueceu a senha? Clique <a href="/users/resetpassword">aqui</a>!</p>
                    <div className="form-actions">
                        <button type="submit" className={"btn btn-primary" + (saving ? " btn-loading" : "")} disabled={saving}>Entrar</button>
                    </div>
                </div>
            </Form>
        </div>
    );
}

export default LoginUser;
